module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9n7n4n-b1edde07df59e15105ae6ece9f67be88.svg";